// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-activity-ideation-votes-counter{display:flex;align-items:center}.task-activity-ideation-votes-counter__title{flex-shrink:0;margin-right:10px;font-weight:bold;font-size:60px;line-height:100%}.task-activity-ideation-votes-counter__message{width:80px;font-size:16px;text-align:center}", ""]);
// Exports
module.exports = exports;
